<template>
  <slice
    :id="block._key"
    class="slice--assurance"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <div class="container">
      <div class="row-md justify-center">
        <div class="slice--assurance__inner col-md-10">
          <portable-text
            v-if="hasTitle"
            :blocks="block.title"
            class="text-center mb-1-5 mb-md-2"
          />

          <div class="slice--assurance__list row-md justify-space-between">
            <div
              v-for="item in block.elements"
              :key="item._id"
              class="col col-md-4 mb-2 mb-md-0"
            >
              <icon-satisfait
                v-if="item.type === 'satisfait'"
                class="mb-0-6 mb-md-1"
              />
              <icon-return
                v-else-if="item.type === 'taille'"
                class="mb-0-6 mb-md-1"
              />
              <icon-transport v-else class="mb-0-6 mb-md-1" />

              <portable-text
                v-if="item.text && item.text.length"
                :blocks="item.text"
                class="text-small text-color-tertiary"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import PortableText from '@/components/RichText/PortableText'

import IconSatisfait from '@/components/icons/Satisfait'
import IconReturn from '@/components/icons/Return'
import IconTransport from '@/components/icons/Transport'

export default {
  name: 'BlockAssurance',
  components: {
    Slice,
    PortableText,
    IconSatisfait,
    IconReturn,
    IconTransport,
  },
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    hasTitle() {
      return this.block.title && this.block.title.length > 0
    },
  },
}
</script>

<style lang="scss">
.slice--assurance {
  @include mq($until: tablet) {
    background: var(--secondary-color);
  }

  &__inner {
    color: var(--tertiary-color);

    @include mq($until: tablet) {
      text-align: center;
      padding: rem($spacing * 4) 0 rem($spacing * 2);
    }

    @include mq($from: tablet) {
      padding: rem($spacing * 4);
      background: var(--secondary-color);
    }
  }

  &__list {
    --grid-padding: calc(var(--spacing) * 2);

    .portable-text {
      --portable-title-margin: calc(var(--spacing));
      --portable-text-margin: calc(var(--spacing));
    }

    h3 {
      font-size: var(--h4-font-size);
      text-align: center;
    }
  }

  .icon {
    display: block;
    width: auto;
    height: rem(128px);
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
